import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { UserDTO } from '../model/UserDTO';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { Page } from '../model/Page';
import { ClientDTO } from '../model/ClientDTO';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ClientService {

    private BASE_URL = '/Client';
    private ALL = '/all';
    private DELETE_MANY = '/deletemany'

    constructor(private http: HttpService) { }

    getById(id: string): Observable<ClientDTO> {
        return this.http.get<ClientDTO>(this.BASE_URL + '/' + id.toString()).pipe(
            map(response => {
                var client = new ClientDTO();
                client.fillFromJSON(response);
                return client;
            })
        );
    }

    getAll(text?: string): Observable<ClientDTO[]> {
      var httpParams = new HttpParams();
      if (text) {
          httpParams = httpParams.append('searchKey', text);
      }
      return this.http.get<ClientDTO[]>(this.BASE_URL + this.ALL, httpParams).pipe(
          map(response => {
            let results = response.map(item => {
              var client = new ClientDTO();
              client.fillFromJSON(item);
              return client;
            })
            return results;
          })
      );
    }

    getList(currentPage: number, pageSize: number, text: string): Observable<Page<ClientDTO>> {
        var httpParams = new HttpParams();
        httpParams = httpParams.append('currentPage', currentPage.toString());
        httpParams = httpParams.append('pageSize', pageSize.toString());
        if (text) {
            httpParams = httpParams.append('searchKey', text);
        }
        return this.http.get<Page<ClientDTO>>(this.BASE_URL, httpParams).pipe(
            map(response => {
              var obj = new Page<ClientDTO>();
              obj.currentPage = response.currentPage;
              obj.length = response.length;
              obj.pageSize = response.pageSize;
              obj.results = response.results.map(item => {
                var client = new ClientDTO();
                client.fillFromJSON(item);
                return client;
              })
              return obj;
            })
        );
    }

    create(client: ClientDTO): Observable<any> {
        //let formData:FormData = new FormData();
        
        /*if (market.id) {
          formData.append('id', market.id.toString());
        }
        formData.append('name', market.name);
        if (market.file) {
          formData.append('file', market.file);
        }
        if (market.logoUrl) {
          formData.append('logoUrl', market.logoUrl);
        }*/
    
        return this.http.post<ClientDTO>(this.BASE_URL, null, client);
      }

      update(client: ClientDTO): Observable<any> {
        return this.http.put<ClientDTO>(this.BASE_URL, client);
      }
      
      deleteMany(ids: string[]): Observable<any> {
        return this.http.post<any>(this.BASE_URL + this.DELETE_MANY, null, ids);
      }

}
